import React, { useContext } from "react";
import { Router } from "@reach/router";
import Admin from "./Admin";
import Analitica from "./Analiticas";
import { UserContext } from "../context/UserContext";
import MobileMenu from "../components/common/MobileMenu";
import PanelNavbar from "../components/global/PanelNavbar";

const Panel = () => {
  const { user, signOut } = useContext(UserContext);

  return (
    <div className="container-fluid px-0">
      <MobileMenu signOut={signOut} user={user} />
      <div className="sidebar">
        <PanelNavbar user={user} signOut={signOut} />
      </div>
      <div className="main-panel bg-light">
        <div className="content overflow-x-hidden">
          <Router>
            <Admin path="/*" default />
            <Analitica path="/analytics/*" />
          </Router>
        </div>
      </div>
    </div>
  );
};

export default Panel;
